import CollectionList from "@/js/Shared/Collections/CollectionList";
import MessageItem    from "../Entities/Message/MessageItem";

export {MessagesSelectionCollection as default};

/**
* Messages Selection Collection
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class MessagesSelectionCollection extends CollectionList {
  /**
   * Total read messages selected
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  read = 0;

  /**
   * Total unread messages selected
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  unread = 0;

  /**
   * Total flagged messages selected
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  flagged = 0;


  /**
   * Total unflagged messages selected
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Number}
   */
  unflagged = 0;

  /**
   * Constructor
   *
   * @public
   *
   * @since 7.0.0
   */
  constructor() {
    super('id');
  }

  /**
   * Returns selection recipient emails
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {Array}
   */
  getRecipientEmails() {
    let recipients = [];
    let emails     = {};

    this.items.forEach(message => {
      if (!message.sender.email) {
        return;
      }

      if (emails[message.sender.email]) {
        return;
      }

      recipients.push(message.sender.email);
      emails[message.sender.email] = true;
    });

    return recipients;
  }

  /**
   * Adds dummy message items to selection
   * by creating a new message item
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Array} ids messages ids
   *
   * @return {void}
   */
  addDummyMessages(messages_ids) {
    messages_ids.forEach((id) => {
      let message = new MessageItem();
      message.id  = id;
      this.add(message);
    })
  }

  /**
   * Adds a message to the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {MessageItem} message
   *
   * @return {Boolean}
   */
  add(message) {
    if (super.exists(message.id) === true) {
      return false;
    }

    if (message.flags.read === true) {
      this.read++;
    }

    if (message.flags.read === false) {
      this.unread++;
    }

    if (message.flags.flagged === true) {
      this.flagged++;
    }

    if (message.flags.flagged === false) {
      this.unflagged++;
    }

    return super.add(message);
  }

  /**
   * Deletes a message from the collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} message_id
   *
   * @return {Boolean}
   */
  delete(message_id) {
    if (super.exists(message_id) === false) {
      return false;
    }

    if (this.index[message_id].flags.read === true) {
      this.read--;
    }

    if (this.index[message_id].flags.read === false) {
      this.unread--;
    }

    if (this.index[message_id].flags.flagged === true) {
      this.flagged--;
    }

    if (this.index[message_id].flags.flagged === false) {
      this.unflagged--;
    }

    return super.delete(message_id);
  }

  /**
   * Recounts all message flags
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  reload() {
    this.resetFlags();

    this.items.forEach((message) => {
      if (message.flags.flagged) {
        this.flagged++;
      }

      if (!message.flags.flagged) {
        this.unflagged++;
      }

      if (message.flags.read) {
        this.read++;
      }

      if (!message.flags.read) {
        this.unread++;
      }
    })
  }

  /**
   * Resets all flags counter
   *
   * @private
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  resetFlags() {
    this.read      = 0;
    this.unread    = 0;
    this.unflagged = 0;
    this.flagged   = 0;
  }

  /**
   * Resets Collection
   *
   * @public
   *
   * @since 7.0.0
   *
   * @return {void}
   */
  reset() {
    this.resetFlags();
    super.reset();
  }
}